export const MAX_COMPARISON_CATEGORIES = 2;

/**
 * Base route names for type-safe route generation
 */
const ROUTE_NAMES = {
    overview: "overview",
    trafficChannels: "traffic_channels",
    geography: "geography",
    demography: "demography",
    players: "players",
    segmentation: "segmentation",
    demandTrends: "demand_trends",
    abstractParent: "abstract_parent",
} as const;

/**
 * Legacy Market Research Routes
 */
export const LEGACY_ROUTES = {
    overview: `market_research_${ROUTE_NAMES.overview}`,
    trafficChannels: `market_research_${ROUTE_NAMES.trafficChannels}`,
    geography: `market_research_${ROUTE_NAMES.geography}`,
    demography: `market_research_${ROUTE_NAMES.demography}`,
    players: `market_research_${ROUTE_NAMES.players}`,
    segmentation: `market_research_${ROUTE_NAMES.segmentation}`,
    demandTrends: `market_research_${ROUTE_NAMES.demandTrends}`,
} as const;

export type LegacyRoute = (typeof LEGACY_ROUTES)[keyof typeof LEGACY_ROUTES];

/**
 * V2 Market Research Routes
 * These are the improved routes with query-based category parameters
 * supporting multiple categories for comparison
 */
export const V2_ROUTES = {
    abstractParent: `market_research_${ROUTE_NAMES.abstractParent}_v2`,
    overview: `market_research_${ROUTE_NAMES.overview}_v2`,
    trafficChannels: `market_research_${ROUTE_NAMES.trafficChannels}_v2`,
    geography: `market_research_${ROUTE_NAMES.geography}_v2`,
    demography: `market_research_${ROUTE_NAMES.demography}_v2`,
    players: `market_research_${ROUTE_NAMES.players}_v2`,
    segmentation: `market_research_${ROUTE_NAMES.segmentation}_v2`,
    demandTrends: `market_research_${ROUTE_NAMES.demandTrends}_v2`,
} as const;

export type V2Route = (typeof V2_ROUTES)[keyof typeof V2_ROUTES];

export const LEGACY_TO_V2_MAPPING = {
    [LEGACY_ROUTES.overview]: V2_ROUTES.overview,
    [LEGACY_ROUTES.trafficChannels]: V2_ROUTES.trafficChannels,
    [LEGACY_ROUTES.geography]: V2_ROUTES.geography,
    [LEGACY_ROUTES.demography]: V2_ROUTES.demography,
    [LEGACY_ROUTES.players]: V2_ROUTES.players,
    [LEGACY_ROUTES.segmentation]: V2_ROUTES.segmentation,
    [LEGACY_ROUTES.demandTrends]: V2_ROUTES.demandTrends,
} as const;
